import RequestApi from "../../modules/requestApi";
import config from "../../../config.js";

const state = {
  // список рекламы
  advList: [],
  // признак загрузки списка рекламы
  advIsLoaded: false,
  // признак для фильтрации списка рекламы
  advFilter: 0,
  // параметры по умолчанию при создании рекламы
  advDefaultParams: {
    name: "Реклама",
    // адрес для перехода по рекламе
    link: {
      ru: "",
      en: "",
    },
    // отображаемый текст рекламы
    text: {
      ru: "",
      en: "",
    },
    // начало и окончание периода проведения
    start: null,
    end: null,
    params: {
      // для предварительного просмотра на экране
      preview: {
        advertising: `/uploads/default/addPage.png`,
      },
      // загружаемые изображения по размеру и языку
      files: {
        bgXSrus: null,
        bgXSen: null,
        bgXLrus: null,
        bgXLen: null,
      },
      /**
       * кому показывать рекламу:
       * new - новым клиентам
       * again - пришедшим повторно
       * many - пришедшим более нескольких раз (counts)
       */
      clients: {
        new: false,
        again: false,
        many: false,
        counts: 0,
      },
    },
    // список хотспотов
    hotspots: [],
  },
};

const mutations = {
  SET_ADV_LIST(state, data) {
    state.advList = data;
  },
  SET_ADV_IS_LOADED(state, data) {
    state.advIsLoaded = data;
  },
  SET_ADV_ITEM(state, data) {
    // определяем индекс по id
    const index = state.advList.findIndex((item) => item.id === data.id);
    if (index !== -1) {
      // перезаписываем элемент, через удаление, иначе реактивность не срабатывает
      state.advList.splice(index, 1, { ...state.advList[index], ...data });
    }
  },
  SET_ADV_FILTER(state, data) {
    state.advFilter = data;
  },
  // обновляем список хотспотов
  SET_ADV_HOTSPOT(state, data) {
    const index_adv = state.advList.findIndex(
      (item) => item.id === data.advertising_id
    );
    if (index_adv !== -1) {
      if (data.deleted) {
        const index_hotspot = state.advList[index_adv].hotspots.findIndex(
          (item) => item.id === data.id
        );
        if (index_hotspot != -1)
          state.advList[index_adv].hotspots.splice(index_hotspot, 1);
      } else {
        state.advList[index_adv].hotspots.push({
          id: data.id,
          address: data.address,
          title: data.title,
        });
      }
    }
  },
};

const actions = {
  /**
   * Загрузка списка рекламы
   */
  advListLoad({ commit, state }) {
    if (!state.advIsLoaded) {
      return new Promise((resolve, reject) => {
        RequestApi.advList()
          .then((data) => {
            commit("SET_ADV_LIST", data);
            commit("SET_ADV_IS_LOADED", true);
          })
          .catch(reject);
      });
    }
  },
  /**
   * удаление рекламы рекламы
   */
  deleteAdv({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      RequestApi.deleteAdv(params)
        .then((data) => {
          commit(
            "SET_ADV_LIST",
            state.advList.filter((item) => item.id !== params.id)
          );
          resolve(data);
        })
        .catch(reject);
    });
  },
  /**
   * Восстановление рекламы
   */
  recoveryAdv({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      RequestApi.recoveryAdv(params)
        .then((data) => {
          commit("SET_ADV_LIST", [...state.advList, data]);
          resolve(data);
        })
        .catch(reject);
    });
  },
  /**
   * Создание рекламы
   */
  createAdv({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      RequestApi.createAdv(params)
        .then((data) => {
          commit("SET_ADV_LIST", [...state.advList, data]);
          resolve(data);
        })
        .catch(reject);
    });
  },
  /**
   * Дублирование рекламы
   */
  copyAdv({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      RequestApi.copyAdv(params)
        .then((data) => {
          commit("SET_ADV_LIST", [...state.advList, data]);
          resolve(data);
        })
        .catch(reject);
    });
  },
  /**
   * Редактирование рекламы
   */
  editAdv({ commit }, params) {
    if (params.end === "") {
      params.end = null;
    }
    if (params.start === "") {
      params.start = null;
    }
    return new Promise((resolve, reject) => {
      RequestApi.editAdv(params)
        .then((data) => {
          commit("SET_ADV_ITEM", data);
          resolve(data);
        })
        .catch(reject);
    });
  },
  /**
   * Прикрепление хотспота к рекламе
   */
  pinHotspotAdv({ commit }, params) {
    return new Promise((resolve, reject) => {
      RequestApi.hotspotEdit({
        id: params.id,
        advertising_id: params.deleted ? null : params.advertising_id,
      })
        .then((data) => {
          commit("SET_HOTSPOT_ITEM", data);
          commit("SET_ADV_HOTSPOT", params);
          resolve(data);
        })
        .catch(reject);
    });
  },
};

const getters = {
  advList: (state) => (filtered) => {
    let result = state.advList;
    // текущие кампании
    if (filtered === 1) {
      result = result.filter(
        (item) =>
          (item.start && new Date(item.start)) < new Date() &&
          item.end &&
          new Date(item.end) > new Date()
      );
    } // запланированные кампании
    if (filtered === 2) {
      result = result.filter(
        (item) => item.start && new Date(item.start) > new Date()
      );
    }
    // завершенные кампании
    if (filtered === 3) {
      result = result.filter(
        (item) => item.end && new Date(item.end) < new Date()
      );
    }
    return result;
  },
  // возвращает признак для фильтрации рекламы
  advFilter: (state) => {
    return state.advFilter;
  },
  // признак, что список рекламы загружен
  advIsLoaded: (state) => {
    return state.advIsLoaded;
  },
  // получение рекламы по id
  getAdv: (state) => (id) => {
    return state.advList.find((item) => item.id === id);
  },
  // получение свойств рекламы по умолчанию
  advDefaultParams: (state) => {
    return state.advDefaultParams;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
